<template>
  <div class="register-container">
    <div class="register-form">
      <h2 class="title">用户注册</h2>
      <el-form :model="registerForm" :rules="registerRules" ref="registerForm" class="form">
        <el-form-item prop="username">
          <el-input
              v-model="registerForm.username"
              placeholder="用户名"
              prefix-icon="el-icon-user"
              size="medium"
          ></el-input>
        </el-form-item>

        <el-form-item prop="password">
          <el-input
              v-model="registerForm.password"
              type="password"
              placeholder="密码"
              prefix-icon="el-icon-lock"
              size="medium"
          ></el-input>
        </el-form-item>

        <el-form-item prop="realName">
          <el-input
              v-model="registerForm.realName"
              placeholder="真实姓名"
              prefix-icon="el-icon-user-solid"
              size="medium"
          ></el-input>
        </el-form-item>

        <el-form-item prop="phone">
          <el-input
              v-model="registerForm.phone"
              placeholder="手机号"
              prefix-icon="el-icon-phone"
              size="medium"
          ></el-input>
        </el-form-item>

        <el-form-item prop="idCard">
          <el-input
              v-model="registerForm.idCard"
              placeholder="身份证号（可选）"
              prefix-icon="el-icon-document"
              size="medium"
          ></el-input>
        </el-form-item>

        <el-form-item prop="role">
          <el-select
              v-model="registerForm.role"
              placeholder="选择角色"
              style="width: 100%"
              size="medium"
          >
            <el-option label="学员" value="student"></el-option>
            <el-option label="教练" value="coach"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="课程类型" v-if="registerForm.role === 'student'">
          <el-radio-group v-model="registerForm.courseType">
            <el-radio label="c1">C1手动挡</el-radio>
            <el-radio label="c2">C2自动挡</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item>
          <el-button
              type="primary"
              size="medium"
              :loading="loading"
              @click="handleRegister"
              class="register-btn"
          >
            {{ loading ? '注册中...' : '注册' }}
          </el-button>
        </el-form-item>
      </el-form>

      <div class="links">
        <span>已有账号？</span>
        <el-link type="primary" @click="$router.push('/login')">立即登录</el-link>
      </div>
    </div>
  </div>
</template>

<script>
import { authAPI } from '../services/api'

export default {
  name: 'UserRegister',
  data() {
    const validatePhone = (rule, value, callback) => {
      const phoneReg = /^1[3-9]\d{9}$/
      if (!phoneReg.test(value)) {
        callback(new Error('手机号格式不正确'))
      } else {
        callback()
      }
    }

    return {
      loading: false,
      registerForm: {
        username: '',
        password: '',
        realName: '',
        phone: '',
        idCard: '',
        role: 'student'
      },
      registerRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 3, max: 20, message: '用户名长度为3-20个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能少于6位', trigger: 'blur' }
        ],
        realName: [
          { required: true, message: '请输入真实姓名', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' }
        ],
        role: [
          { required: true, message: '请选择角色', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    handleRegister() {
      this.$refs.registerForm.validate(async (valid) => {
        if (valid) {
          this.loading = true
          try {
            const response = await authAPI.register(this.registerForm)

            if (response.success) {
              // 注册成功，显示消息并跳转到登录页面
              this.$message.success(response.message || '注册成功，请登录')

              // 1秒后跳转到登录页面
              setTimeout(() => {
                this.$router.push('/login')
              }, 1000)
            } else {
              this.$message.error(response.message)
            }
          } catch (error) {
            if (error.response && error.response.data) {
              this.$message.error(error.response.data.message)
            } else {
              this.$message.error('注册失败，请检查网络连接')
            }
          } finally {
            this.loading = false
          }
        }
      })
    }
  }
}
</script>

<style scoped>
/* 基础样式重置 & 全局主题变量（与登录页风格统一） */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

:root {
  /* 核心配色：清爽蓝色系（适配驾校业务） */
  --primary: #2c82e0;
  --primary-hover: #2072d0;
  --primary-light: rgba(44, 130, 224, 0.15);
  --secondary: #409eff;
  /* 文本与背景 */
  --text-dark: #303133;
  --text-light: #606266;
  --text-placeholder: #909399;
  --bg-main: linear-gradient(120deg, #f5f7fa 0%, #e4ebf5 100%);
  --form-bg: #ffffff;
  /* 边框与阴影 */
  --border: #dcdfe6;
  --border-hover: #c0c4cc;
  --shadow-light: 0 4px 20px rgba(0, 0, 0, 0.08);
  --shadow-hover: 0 6px 24px rgba(44, 130, 224, 0.15);
  /* 尺寸与过渡 */
  --radius: 12px;
  --input-radius: 8px;
  --form-width: 450px;
  --form-width-mobile: 92%;
  --transition: all 0.3s ease;
}

/* 高对比度模式支持 */
@media (prefers-contrast: high) {
  :root {
    --primary: #0066cc;
    --primary-hover: #0077ee;
    --border: #000000;
  }
  .register-form {
    border: 2px solid var(--border);
  }
  .title::after {
    background: var(--primary);
    height: 4px;
  }
  :deep(.el-input__inner) {
    border-width: 2px;
  }
}

/* 减少动画偏好支持 */
@media (prefers-reduced-motion: reduce) {
  * {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
  .register-form:hover, .register-btn:hover {
    transform: none !important;
  }
  .register-container::before {
    animation: none !important;
  }
  .register-btn::before {
    display: none !important;
  }
}

/* 注册页面主容器 */
.register-container {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--bg-main);
  padding: 20px;
  position: relative;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  overflow: hidden;
}

/* 背景轻装饰动画（低存在感，不干扰核心视觉） */
.register-container::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, var(--primary-light) 1px, transparent 1px);
  background-size: 20px 20px;
  animation: moveBackground 20s linear infinite;
  z-index: 0;
  opacity: 0.8;
}

@keyframes moveBackground {
  0% { transform: translate(0, 0); }
  100% { transform: translate(20px, 20px); }
}

/* 注册表单卡片 */
.register-form {
  width: 100%;
  max-width: var(--form-width);
  padding: 36px 32px;
  background: var(--form-bg);
  border-radius: var(--radius);
  box-shadow: var(--shadow-light);
  position: relative;
  z-index: 1;
  transition: var(--transition);
  backdrop-filter: blur(8px);
}

/* 表单hover交互效果 */
.register-form:hover {
  box-shadow: var(--shadow-hover);
  transform: translateY(-3px);
}

/* 标题样式 */
.title {
  text-align: center;
  margin-bottom: 30px;
  color: var(--text-dark);
  font-size: 24px;
  font-weight: 600;
  position: relative;
  padding-bottom: 12px;
  line-height: 1.4;
}

.title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background: var(--primary);
  border-radius: 2px;
  transition: var(--transition);
}

.register-form:hover .title::after {
  width: 80px;
}

/* 表单区域间距 */
.form {
  margin-bottom: 20px;
}

/* 表单项间距优化（适配多表单项） */
.el-form-item {
  margin-bottom: 22px;
}

/* 输入框基础样式 */
:deep(.el-input__inner) {
  border: 1px solid var(--border);
  border-radius: var(--input-radius);
  padding: 12px 15px 12px 40px;
  font-size: 14px;
  color: var(--text-dark);
  background: var(--form-bg);
  transition: var(--transition);
  height: 44px;
}

/* 输入框聚焦样式 */
:deep(.el-input__inner:focus) {
  border-color: var(--primary);
  box-shadow: 0 0 0 2px var(--primary-light);
  outline: none;
}

/* 输入框前缀图标颜色 */
:deep(.el-input__prefix) {
  color: var(--primary);
  font-size: 16px;
}

/* 输入框占位符样式 */
:deep(.el-input__inner::placeholder) {
  color: var(--text-placeholder);
}

/* 下拉选择器样式优化 */
:deep(.el-select .el-input__inner) {
  padding-right: 35px;
}

:deep(.el-select .el-input__suffix) {
  color: var(--primary);
}

:deep(.el-select-dropdown__item.selected) {
  color: var(--primary);
  font-weight: 500;
}

/* 单选按钮组样式优化（课程类型选择） */
:deep(.el-radio-group) {
  display: flex;
  gap: 20px;
  align-items: center;
}

:deep(.el-radio__inner) {
  border-color: var(--primary);
  transition: var(--transition);
}

:deep(.el-radio__input.is-checked .el-radio__inner) {
  background-color: var(--primary);
  border-color: var(--primary);
}

:deep(.el-radio__input.is-checked+.el-radio__label) {
  color: var(--primary);
  font-weight: 500;
}

:deep(.el-radio__label) {
  color: var(--text-light);
  transition: var(--transition);
}

/* 注册按钮样式 */
.register-btn {
  width: 100%;
  height: 44px;
  background: var(--primary);
  border: none;
  border-radius: var(--input-radius);
  color: #ffffff;
  font-size: 16px;
  font-weight: 500;
  transition: var(--transition);
  position: relative;
  overflow: hidden;
  margin-top: 10px;
}

/* 按钮流光效果 */
.register-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent);
  transition: left 0.5s ease;
}

.register-btn:hover::before {
  left: 100%;
}

/* 按钮hover/active效果 */
.register-btn:hover {
  background: var(--primary-hover);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px var(--primary-light);
}

.register-btn:active {
  transform: translateY(0);
}

/* 按钮加载状态样式 */
:deep(.el-button--primary.is-loading) {
  opacity: 0.9;
}

/* 加载动画样式优化 */
:deep(.el-loading-spinner .circular) {
  animation: loading-rotate 2s linear infinite;
}
:deep(.el-loading-spinner .path) {
  animation: loading-dash 1.5s ease-in-out infinite;
  stroke: var(--primary);
  stroke-dasharray: 90, 150;
  stroke-dashoffset: 0;
  stroke-width: 2;
}
@keyframes loading-rotate {
  100% { transform: rotate(360deg); }
}
@keyframes loading-dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -40px;
  }
  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -120px;
  }
}

/* 链接区域样式 */
.links {
  text-align: center;
  font-size: 14px;
  color: var(--text-light);
  margin-top: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
}

/* 登录链接样式 */
.links .el-link {
  color: var(--primary);
  transition: var(--transition);
  font-weight: 500;
}
.links .el-link:hover {
  color: var(--primary-hover);
  transform: translateX(2px);
}

/* 表单错误状态增强 */
:deep(.el-form-item.is-error .el-input__inner) {
  border-color: #f56c6c;
  box-shadow: 0 0 0 2px rgba(245, 108, 108, 0.15);
}

/* 焦点可见性增强（无障碍） */
:deep(.el-input__inner:focus-visible) {
  outline: 2px solid var(--primary);
  outline-offset: 2px;
}

/* 响应式适配 - 平板/小屏 */
@media (max-width: 768px) {
  .register-container {
    padding: 15px;
  }
  .register-form {
    width: var(--form-width-mobile);
    padding: 32px 28px;
  }
  .title {
    font-size: 22px;
    margin-bottom: 26px;
  }
  .el-form-item {
    margin-bottom: 20px;
  }
  :deep(.el-input__inner) {
    height: 42px;
    padding: 10px 14px;
  }
  .register-btn {
    height: 42px;
    font-size: 15px;
  }
}

/* 响应式适配 - 手机 */
@media (max-width: 480px) {
  .register-form {
    padding: 28px 24px;
  }
  .title {
    font-size: 20px;
    margin-bottom: 22px;
  }
  .form {
    margin-bottom: 15px;
  }
  .el-form-item {
    margin-bottom: 18px;
  }
  :deep(.el-input__inner) {
    height: 40px;
    padding: 10px 12px 10px 34px;
  }

  .register-btn {
    height: 40px;
    font-size: 14px;
  }
  /* 单选按钮组移动端纵向排列 */
  :deep(.el-radio-group) {
    flex-direction: column;
    gap: 10px;
    align-items: flex-start;
  }
  .links {
    flex-direction: column;
    gap: 8px;
  }
}

/* 响应式适配 - 超小屏 */
@media (max-width: 360px) {
  .register-form {
    padding: 24px 20px;
  }
  .title {
    font-size: 18px;
  }
}

/* 移动端消息提示优化 */
@media (max-width: 768px) {
  :deep(.el-message) {
    width: 90% !important;
    min-width: auto !important;
    max-width: 320px !important;
    margin: 0 auto !important;
    left: 50% !important;
    transform: translateX(-50%) !important;
    border-radius: 10px !important;
    box-shadow: 0 6px 16px rgba(0,0,0,0.15) !important;
  }
  :deep(.el-message--top) {
    top: 20px !important;
  }
  :deep(.el-message__content) {
    font-size: 15px !important;
    line-height: 1.4 !important;
    text-align: center !important;
  }
}
</style>
